import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AuthenticationService} from '../../services/authentication/authentication.service';
import {MatDialog} from '@angular/material/dialog';
import {LoginDialogComponent} from '../../components/login-dialog/login-dialog.component';

export const authenticationGuard: CanActivateFn = (route, state) => {

    const authService = inject(AuthenticationService);
    const dialog = inject(MatDialog);
    const router = inject(Router)

    if (authService.isAuthenticated()) {
        return true
    } else {
        router.navigate(['/anmeldung'])
        return false
    }
};
